// @flow
import env from '../../environment';
import {getCreator, postCreator} from '../../http';

export const endpoints = Object.freeze({
  FETCH_NOTIFICATIONS: `${env.baseApiUrl}/usher/notification`,
  SEEN_NOTIFICATION: `${env.baseApiUrl}/usher/notification/:notificationId/review`,
  SEEN_ALL_NOTIFICATIONS: `${env.baseApiUrl}/usher/notification/review`,

  NOTIFICATION_STREAM_AUTH: `${env.baseApiUrl}/usher/notification/sse/authenticate`,
  NOTIFICATION_STREAM: `${env.baseApiUrl}/mercury/sse/store-notification/stream`,
});

export const getNotificationsApi = getCreator(endpoints.FETCH_NOTIFICATIONS);
export const seenNotificationApi = postCreator(endpoints.SEEN_NOTIFICATION);
export const seenAllNotificationsApi = postCreator(
  endpoints.SEEN_ALL_NOTIFICATIONS
);

export const getRealTimeAuthenticationTokenEndpoint = postCreator(
  endpoints.NOTIFICATION_STREAM_AUTH
);

export type RealTimeAuthenticationTokenResponse = {
  token: string,
};
